
import { SearchProvider } from '@/context/SearchContext';
import SearchResultsContent from '@/components/search/SearchResultsContent';

// Main component that provides the search context
const SearchResults = () => {
  return (
    <SearchProvider>
      <SearchResultsContent />
    </SearchProvider>
  );
};

export default SearchResults;
